import * as React from 'react';
import styled from 'styled-components';
import { FormInputProps } from '../../Deprecated/JRCFormFieldRender';

const ToggleWrapper = styled.div`
    flex-shrink: 0;
    margin: 5px 8px 5px 0;
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    width: 28px;
    height: 16px;

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    span {
        position: absolute;
        border-radius: 8px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${(props) => props.theme.color.grey1};
        border: 1px solid ${(props) => props.theme.color.grey3};
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    span:before {
        position: absolute;
        content: '';
        height: 12px;
        width: 12px;
        border-radius: 50%;
        left: 1px;
        bottom: 1px;
        background-color: white;
        -webkit-transition: 0.4s;
        transition: 0.4s;
    }

    input:checked + span {
        background-color: ${(props) => props.theme.color.primary};
        border: 1px solid ${(props) => props.theme.color.primaryD20};
    }

    input:checked + span:before {
        -webkit-transform: translateX(12px);
        -ms-transform: translateX(12px);
        transform: translateX(12px);
    }

    input:disabled + span {
        background-color: ${(props) => props.theme.color.white};
        border: 1px solid ${(props) => props.theme.color.grey2};
        cursor: default;
        &:before {
            background-color: ${(props) => props.theme.color.grey2};
        }
    }
`;
const Toggle = function (props: FormInputProps, ref: React.ForwardedRef<HTMLInputElement>) {
    return (
        <ToggleWrapper>
            <input {...props} type="checkbox" ref={ref}></input>
            {/* empty span for toggle styling */}
            <span></span>
        </ToggleWrapper>
    );
};
export const JRCToggle = React.forwardRef(Toggle);
